import React, { useState, useEffect } from "react";
import styles from "./CustomFilter.module.css";
import AddIcon from "../../assets/icons/addEcl.svg";
import RemoveIcon from "../../assets/icons/removeLoansIcons.svg";
import CustomDropdown from "../Forms/CustomDropdown/CustomDropdown";

const CustomFilter = ({
  onClose,
  onApply,
  filterConfig = [],
  appliedFilters = [],
}) => {
  const getInitialFilters = () => {
    if (appliedFilters && appliedFilters.length > 0) {
      return appliedFilters.map((f, idx) => {
        const selectedConfig = filterConfig.find(
          (item) => item.key === f.field || item.name === f.fieldLabel
        );
        return {
          id: f.id || Date.now() + idx,
          field: f.field || selectedConfig?.key || "",
          fieldLabel: f.fieldLabel || selectedConfig?.name || "",
          dataType: f.dataType || selectedConfig?.type || "text",
          type: f.type || "",
          value: f.value !== undefined ? f.value : "",
        };
      });
    }
    return [
      { id: 1, field: "", fieldLabel: "", dataType: "", type: "", value: "" },
    ];
  };

  const [filters, setFilters] = useState(getInitialFilters);

  useEffect(() => {
    if (appliedFilters && appliedFilters.length > 0) {
      setFilters(
        appliedFilters.map((f, idx) => {
          const selectedConfig = filterConfig.find(
            (item) => item.key === f.field || item.name === f.fieldLabel
          );
          return {
            id: f.id || Date.now() + idx,
            field: f.field || selectedConfig?.key || "",
            fieldLabel: f.fieldLabel || selectedConfig?.name || "",
            dataType: f.dataType || selectedConfig?.type || "text",
            type: f.type || "",
            value: f.value !== undefined ? f.value : "",
          };
        })
      );
    }
  }, [appliedFilters, filterConfig]);

  const handleAddFilter = () => {
    setFilters((prev) => [
      ...prev,
      { id: Date.now(), field: "", fieldLabel: "", dataType: "", type: "", value: "" },
    ]);
  };

  const handleRemoveFilter = (id) => {
    if (filters.length > 1) {
      setFilters((prev) => prev.filter((f) => f.id !== id));
    } else {
      setFilters([
        { id: 1, field: "", fieldLabel: "", dataType: "", type: "", value: "" },
      ]);
    }
  };

  const handleFilterChange = (id, key, val) => {
    setFilters((prev) =>
      prev.map((f) => (f.id === id ? { ...f, [key]: val } : f))
    );
  };

  const handleResetAll = () => {
    setFilters([
      { id: 1, field: "", fieldLabel: "", dataType: "", type: "", value: "" },
    ]);
  };

  const handleApply = () => {
    const completeFilters = filters.filter((f) => {
      const hasValue =
        f.value !== "" || f.type === "is empty" || f.type === "is not empty";
      return Boolean(f.field && f.type && hasValue);
    });

    const payload = completeFilters.map((f) => {
      const selectedConfig = filterConfig.find(
        (item) => item.key === f.field || item.name === f.fieldLabel
      );
      return {
        field: f.field,
        dataType: f.dataType || selectedConfig?.type || "text",
        type: f.type,
        value: f.value,
      };
    });

    onApply?.(payload);
  };

  const completeFilters = filters.filter((f) => {
    const hasValue =
      f.value !== "" || f.type === "is empty" || f.type === "is not empty";
    return Boolean(f.field && f.type && hasValue);
  });

  const hasAppliedFilters =
    Array.isArray(appliedFilters) && appliedFilters.length > 0;

  return (
    <div className={styles.backdrop}>
      <div className={styles.container}>
        <div className={styles.header}>
          <div className={styles.headerLeft}>
            <h3 className={styles.title}>Filters</h3>
            <span className={styles.appliedCount}>
              {completeFilters.length} applied
            </span>
          </div>
          <button className={styles.resetButton} onClick={handleResetAll}>
            Reset all
          </button>
        </div>

        <div className={styles.filtersContainer}>
          {filters.map((filter) => {
            const selectedConfig = filterConfig.find(
              (item) => item.key === filter.field
            );

            return (
              <div key={filter.id} className={styles.filterRow}>
                <label className={styles.label}>Where</label>

                <div className={styles.filterInputs}>
                  <div className={styles.dropdownWrapper}>
                    <CustomDropdown
                      placeholder="Identifier"
                      value={filter.fieldLabel}
                      options={filterConfig.map((opt) => opt.name)}
                      height="35px"
                      onChange={(selectedName) => {
                        const selectedItem = filterConfig.find(
                          (item) => item.name === selectedName
                        );

                        if (selectedItem) {
                          setFilters((prev) =>
                            prev.map((f) =>
                              f.id === filter.id
                                ? {
                                    ...f,
                                    field: selectedItem.key,
                                    fieldLabel: selectedItem.name,
                                    dataType: selectedItem.type,
                                    type: "",
                                    value: "",
                                  }
                                : f
                            )
                          );
                        }
                      }}
                    />
                  </div>

                  <div className={styles.dropdownWrapper}>
                    <CustomDropdown
                      placeholder="Relative"
                      value={filter.type}
                      options={selectedConfig?.filterTypes || []}
                      height="35px"
                      onChange={(selectedType) =>
                        handleFilterChange(filter.id, "type", selectedType)
                      }
                    />
                  </div>

                  <div className={styles.dropdownWrapper}>
                    {selectedConfig?.type === "number" ? (
                      <input
                        type="number"
                        className={styles.input}
                        placeholder="Enter value"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(filter.id, "value", e.target.value)
                        }
                      />
                    ) : selectedConfig?.type === "date" ? (
                      <input
                        type="date"
                        className={styles.input}
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(filter.id, "value", e.target.value)
                        }
                      />
                    ) : (
                      <input
                        type="text"
                        className={styles.input}
                        placeholder="Enter value"
                        value={filter.value}
                        onChange={(e) =>
                          handleFilterChange(filter.id, "value", e.target.value)
                        }
                      />
                    )}
                  </div>

                  <button
                    type="button"
                    className={styles.removeButton}
                    onClick={() => handleRemoveFilter(filter.id)}
                    title="Remove filter"
                  >
                    <img src={RemoveIcon} alt="remove" />
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.footer}>
          <button className={styles.cancelButton} onClick={onClose}>
            Cancel
          </button>
          <div className={styles.footerRight}>
            <button
              className={styles.addFilterButton}
              onClick={handleAddFilter}
            >
              <img src={AddIcon} alt="add" /> Add Filter
            </button>
            <button
              className={styles.applyButton}
              onClick={handleApply}
              disabled={completeFilters.length === 0 && !hasAppliedFilters}
            >
              Apply Filter
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomFilter;
